/* eslint-disable
    func-names,
    no-multi-assign,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PermissionsBase from "permissions/permissions_base";

let CommentsSignedInPermissions;

export default CommentsSignedInPermissions = (function () {
  CommentsSignedInPermissions = class CommentsSignedInPermissions extends PermissionsBase {
    static initClass() {
      // permissions for signed in user
      this.prototype.permissions = {
        _renderCommentRecommendsView: true,
        _renderSignInToCommentButtonView: false,
        _renderNewCommentButtonView: true,
        _renderContentSubscriptionIndicatorView: true,
        _renderReportButton: true,
        _renderReplyButton: true,
        _renderModeratorControls: false,
        _renderEditorControls: false,
      };
    }
  };
  CommentsSignedInPermissions.initClass();
  return CommentsSignedInPermissions;
}());
